<template>
  <v-card>
    <v-card-title class="grey lighten-3">Edit Message</v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md pa-0>
        <v-layout row>
          <v-flex sm6 pr-3>
            <v-text-field
              v-if="contactItemEdit.useHeadOfficeEmail"
              label="Head Office Email"
              v-model="contactItemEdit.headOfficeEmail"
              :error-messages="emailErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
            <v-text-field
              v-else
              label="Email"
              v-model="contactItemEdit.supplierEmail"
              :error-messages="emailErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
          <v-flex sm6>
            <v-text-field
              label="Subject"
              v-model="contactItemEdit.subject"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex sm12>
            <v-textarea
              outline
              label="Notes"
              rows="8"
              v-model="contactItemEdit.notes"
              :outlined="outlinedInputs"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout align-baseline>
          <v-checkbox v-model="sendCc" label="CC to:" class="mr-3"></v-checkbox>
          <v-text-field
            v-model="ccToEmail"
            label="Email"
            class="mt-0 pt-0"
            :error-messages="ccEmailErrors"
            :disabled="!sendCc"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions class="grey lighten-4">
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="closeDialog">Cancel</v-btn>
      <v-btn color="primary" @click="onSave">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { EmailsValidator } from "../../../../helpers/validators/emails-validator";

export default {
  name: "ItineraryDetailsContactSuppliersEdit",

  props: {
    contactItem: {
      type: Object,
      default: () => {},
    },
    defaultCc: {
      type: String,
      default: "",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      contactItemEdit: { ...this.contactItem },
      sendCc: this.defaultCc != "",
      ccToEmail:
        this.contactItem.cc != "" ? this.contactItem.cc : this.defaultCc,
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    emailErrors() {
      let errors = [];
      if (!this.$v.contactItemEdit.supplierEmail.$dirty) {
        return errors;
      }

      if (!this.$v.contactItemEdit.supplierEmail.required) {
        errors.push("Email is required.");
      }

      if (!this.$v.contactItemEdit.supplierEmail.EmailsValidator) {
        errors.push("Input must be an email.");
      }

      return errors;
    },
    ccEmailErrors() {
      let errors = [];
      if (this.sendCc) {
        if (!this.$v.ccToEmail.$dirty) {
          return errors;
        }

        if (!this.$v.ccToEmail.required) {
          errors.push("Email is required.");
        }

        if (!this.$v.ccToEmail.EmailsValidator) {
          errors.push("Input must be an email.");
        }
        return errors;
      } else {
        return [];
      }
    },
  },

  methods: {
    closeDialog() {
      this.$emit("closeContactEditDialog");
    },
    onSave() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.sendCc) {
          this.contactItemEdit.cc = this.ccToEmail;
        } else {
          this.contactItemEdit.cc = "";
        }
        this.$emit("onSaveEdit", { ...this.contactItemEdit });
        this.ccToEmail = "";
        this.sendCc = false;
      }
    },
  },

  watch: {
    contactItem(data) {
      this.contactItemEdit = { ...data };
      this.ccToEmail =
        this.contactItem.cc != "" ? this.contactItem.cc : this.defaultCc;
    },
    dialog(value) {
      if (value) {
        this.ccToEmail =
          this.contactItem.cc != "" ? this.contactItem.cc : this.defaultCc;
        this.sendCc = this.contactItem.cc != "" || this.defaultCc != "";
      } else {
        this.$v.$reset();
      }
    },
  },

  validations() {
    if (this.sendCc) {
      return {
        contactItemEdit: {
          supplierEmail: { required, EmailsValidator },
        },
        ccToEmail: { required, EmailsValidator },
      };
    } else {
      return {
        contactItemEdit: {
          supplierEmail: { required, EmailsValidator },
        },
      };
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/contact-suppliers/ItineraryDetailsContactSuppliersEdit.vue